import { wirelessBreadcrumbsConfig } from '../core/breadcrumbs/breadcrumbs.config';
import { RouteBreadcrumbsConfig } from '../core/breadcrumbs/breadcrumbs.model';

export const changeVoicemailBreadcrumbConfig: RouteBreadcrumbsConfig = {
  breadcrumbsData: [
    wirelessBreadcrumbsConfig,
    {
      copy: 'change-voicemail-password.header',
      val: '',
    },
  ],
  regexp: /^change-voicemail-password(.+)?/,
  useRegEx: true,
  key: 'change-voicemail-password',
};
